export const getIsFetching = state => state.recoverPassword.isFetching;
export const getCode = state => state.recoverPassword.data.code;
export const getErrorMessage = state => state.recoverPassword.errorMessage;
